import { render, staticRenderFns } from "./OverviewStat.vue?vue&type=template&id=b345f878&"
import script from "./OverviewStat.vue?vue&type=script&lang=js&"
export * from "./OverviewStat.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports